/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import {
    IconArrowAutofitWidth,
    IconArrowMergeBoth,
    IconArrowsSplit,
    IconColumnInsertLeft,
    IconColumnInsertRight,
    IconColumnRemove,
    IconRowInsertBottom,
    IconRowInsertTop,
    IconRowRemove,
    IconTableColumn,
    IconTableMinus,
    IconTableRow,
} from "@tabler/icons-react";
import { useCurrentEditor } from "@tiptap/react";
import { useTranslation } from "react-i18next";
import { ToolbarButton } from "./toolbar-button/toolbar-button";
import { ToolbarButtonGroup } from "./toolbar-button/toolbar-button-group";
import { ToolbarRow } from "./toolbar-row";

const TableButtons = () => {
    
    const { editor } = useCurrentEditor();
    const { t } = useTranslation();

    if (!editor.can().deleteTable()) {
        return null;
    }

    return (
        <ToolbarRow>
            {/* table */}
            <ToolbarButtonGroup>
                <ToolbarButton command='deleteTable' icon={IconTableMinus} tooltip={t("Editor.removeTable")} />
            </ToolbarButtonGroup>

            {/* columns */}
            <ToolbarButtonGroup>
                <ToolbarButton command='toggleHeaderColumn' icon={IconTableColumn} tooltip={t("Editor.headerColumn")} />
                <ToolbarButton
                    command='addColumnBefore'
                    icon={IconColumnInsertLeft}
                    tooltip={t("Editor.addColumnBefore")}
                />
                <ToolbarButton
                    command='addColumnAfter'
                    icon={IconColumnInsertRight}
                    tooltip={t("Editor.addColumnAfter")}
                />
                <ToolbarButton command='deleteColumn' icon={IconColumnRemove} tooltip={t("Editor.deleteColumn")} />
            </ToolbarButtonGroup>

            {/* rows */}
            <ToolbarButtonGroup>
                <ToolbarButton command='toggleHeaderRow' icon={IconTableRow} tooltip={t("Editor.headerRow")} />
                <ToolbarButton command='addRowBefore' icon={IconRowInsertTop} tooltip={t("Editor.addRowBefore")} />
                <ToolbarButton command='addRowAfter' icon={IconRowInsertBottom} tooltip={t("Editor.addRowAfter")} />
                <ToolbarButton command='deleteRow' icon={IconRowRemove} tooltip={t("Editor.deleteRow")} />
            </ToolbarButtonGroup>

            {/* cells */}
            <ToolbarButtonGroup>
                <ToolbarButton command='mergeCells' icon={IconArrowMergeBoth} tooltip={t("Editor.mergeCells")} />
                <ToolbarButton command='splitCell' icon={IconArrowsSplit} tooltip={t("Editor.splitCell")} />
                <ToolbarButton command='removeColumnWidth' icon={IconArrowAutofitWidth} tooltip={t("Editor.removeColWidth")} />
            </ToolbarButtonGroup>
        </ToolbarRow>
    );
};
export { TableButtons };
